import PageWrapper from '../components/basic/PageWrapper';
import IntroSection from '../components/components/RoadFreight/IntroSection';
import ServicesGrid from '../components/components/RoadFreight/ServicesGrid';
import ParallaxServices from '../components/components/RoadFreight/ParallaxServices';
import IconFeatures from '../components/components/RoadFreight/IconFeatures';
import TestimonialsClients from '../components/components/RoadFreight/TestimonialsClients';

const RoadFreightPage = () => {
	return (
		<PageWrapper>
			<IntroSection />
			<ServicesGrid />
			<IconFeatures />
			<ParallaxServices />
			<TestimonialsClients />
		</PageWrapper>
	);
};

export default RoadFreightPage;
